import React from "react";

const GenesisSyncIcon = ({ className = "", size, width = 64, height = 64, ...props }) => {
  const dim = size || width;
  const dimH = size || height;

  return (
    <svg
      width={dim}
      height={dimH}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M17.8281 32.154C17.8281 25.7517 23.0182 20.5616 29.4205 20.5616H50.5893C56.9916 20.5616 62.1817 25.7517 62.1817 32.154C62.1817 38.5563 56.9916 43.7464 50.5893 43.7464H29.4205C23.0182 43.7464 17.8281 38.5563 17.8281 32.154Z"
        fill="#B3B4B6"
      />
      <path
        d="M55.1317 23.9411C55.1317 32.2919 48.362 39.0616 40.0112 39.0616C31.6603 39.0616 24.8906 32.2919 24.8906 23.9411C24.8906 15.5902 31.6603 8.82051 40.0112 8.82051C48.362 8.82051 55.1317 15.5902 55.1317 23.9411Z"
        fill="#B3B4B6"
      />

      <path
        d="M33.2783 16C39.7934 16 44.1562 20.4889 44.1562 27.165V42.5742C44.1562 49.2315 39.7934 53.7178 33.2783 53.7178H16.6152C10.1004 53.7176 5.71875 49.2313 5.71875 42.5742V27.165C5.71875 20.4891 10.1004 16.0002 16.6152 16H33.2783Z"
        fill="#B3B4B6"
        fillOpacity="0.05"
        stroke="url(#genesisSyncIconStroke)"
        strokeWidth="1.2"
      />

      <g transform="translate(13.2 22.8) scale(0.95)">
        <path
          d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
          fill="url(#genesisSyncIconGlyph)"
        />
      </g>

      <defs>
        <linearGradient
          id="genesisSyncIconStroke"
          x1="11.8374"
          y1="20.3942"
          x2="40.9095"
          y2="52.2979"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.25" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="genesisSyncIconGlyph"
          x1="40.0036"
          y1="22.8225"
          x2="0.86529"
          y2="55.5572"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#999999" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default GenesisSyncIcon;
